import api from '../../services/api';
import { Creators } from '../ducks/sector';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getSectors({ filter }) {
  try {
    let response; 

    yield put(Creators.sectorRequest());
    response = yield call(api.post, 'sector', filter);

    yield put(Creators.sectorSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.sectorError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar setores'
    }));
  }
} 